export interface OpenAvailyArgs {
  treatmentBundleTypeReferenceId?: string
  clinicId?: string
  variant?: AppVariant
}

export enum Variants {
  City = 'city',
  AllClinics = 'allClinics',
}

export type AppVariant = CityVariant | AllClinicsVariant

export type CityVariant = {
  type: Variants.City
  cityName: string
  treatmentBundleTypeReferenceId?: string
}

export type AllClinicsVariant = {
  type: Variants.AllClinics
  treatmentBundleTypeReferenceId?: string
}
